import { NgModule } from '@angular/core';
import { SetFocusDirective } from './set-focus.directive';

@NgModule({
    declarations: [
        SetFocusDirective
    ],
    exports: [
        SetFocusDirective
    ]
})
export class SetFocusModule {}
